import React, { useContext } from "react";
import "./settings-tabs.component.scoped.scss";
import { Box } from "@material-ui/core";
import { NavLink } from "react-router-guard";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../../store";
import { SettingsTabs, SettingsTabsInterface } from "../../types/settings-tab";

const SettingsTabsComponent = () => {
  const { t } = useTranslation();
  const { user } = useContext(GlobalContext);

  return (
    <Box className="settings__tabs">
      <ul>
        {SettingsTabs.map((tab: SettingsTabsInterface, index: number) => {
          return (
            <>
              {tab.roles && tab.roles.includes(user.role) && (
                <li key={index}>
                  <NavLink activeClassName="active" exact to={tab.path}>
                    {t(tab.title)}
                  </NavLink>
                </li>
              )}
            </>
          );
        })}
      </ul>
    </Box>
  );
};

export default SettingsTabsComponent;
